<template>
  <v-card
    flat
    outlined
    class="rounded ma-2"
  >
    <v-img
      class="white--text align-end rounded clickable"
      :height="$vuetify.breakpoint.xsOnly ? '100px' : '150px'"
      :src="activity.coverImageUrl"
      @click="goToActivity()"
    >
      <v-card-title class="related-activity-name px-3 py-2 mb-3">
        <div>{{ activity.name }}</div>
      </v-card-title>
    </v-img>
    <v-card-text v-if="activity.description" class="text--primary pa-0">
      <foldable-card-text
        class="ma-1"
        :minLength="150"
        :height="20"
        light
        :text="activity.description.split('\n')[0]"
      ></foldable-card-text>
    </v-card-text>
  </v-card>
</template>

<script>
import routeNames from '@/router/routes'
export default {
  props: {
    activity: Object,
  },
  methods: {
    goToActivity () {
      this.$router.push({
        name: routeNames.activity_details.name,
        params: { activityId: this.activity.id },
      })
    },
  },
  components: {
    FoldableCardText: () => import('@/components/app-components/FoldableCardText.vue'),
  },
}
</script>
<style lang="scss" scoped>
.rounded {
  border-radius: 8px !important;
}
.related-activity-name {
  word-break: break-word;
  position: relative;
  :first-child {
    background: none;
    max-width: inherit;
    display: inline-block;
    z-index: 1;
  }
  ::after {
    content: '';
    width: 100%;
    height: 100%;
    background-color: var(--v-secondary-darken1);
    opacity: 0.4;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
}
</style>
